import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CreditLineMockBackEndService {
  private readonly PARENT_COMPANY_NAME = 'Amadeus  Parent (TEST)';
  private readonly CHILD_COMPANY_NAME = 'Amadeus  Child (TEST)';
  private readonly CHILD_OFFICE = 'NCE1A2261';
  private readonly USD_TO_BGN_RATE = 1.79;
  private readonly BGN_TO_EURO_RATE = 0.51;
  private readonly USD_TO_EURO_RATE = 0.92;

  constructor() {}

  public getActiveCreditLineStatusNoNetwork(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          companyName: 'Example Travel Company',
          initialAmount: 100000,
          openAmount: 75000,
          percentageUsed: 25,
          usedAmount: 25000,
          salesCurrency: 'EUR',
          hierarchyLevel: 0,
          isCreditLineActivated: true,
          isCreditLineCustomer: true,
          creditLineModel: 'Shared',
          subAgencies: []
        }
      },
      statusCodeValue: 200,
      statusCode: 'OK'
    };
  }

  public getNotActiveCreditLineStatusNoNetwork(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId,
          isCreditLineActivated: false,
          isCreditLineCustomer: true,
          creditLineModel: 'Shared',
          subAgencies: []
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusNotCreditLineCustomer(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          isCreditLineActivated: true,
          isCreditLineCustomer: false,
          creditLineModel: 'Shared',
          subAgencies: []
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusDataNotFoundForOfficeId(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusTwoLevelNetworkParentNegativeAmount(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          companyName: this.PARENT_COMPANY_NAME,
          initialAmount: 2000.0,
          openAmount: -1000.0,
          percentageUsed: 50.0,
          usedAmount: 1000.0,
          salesCurrency: 'EUR',
          hierarchyLevel: 2,
          isCreditLineActivated: true,
          isCreditLineCustomer: true,
          creditLineModel: 'Shared',
          subAgencies: [
            {
              officeId: this.CHILD_OFFICE,
              companyName: this.CHILD_COMPANY_NAME,
              initialAmount: 2000.0,
              openAmount: -1000.0,
              percentageUsed: 50.0,
              usedAmount: 1000.0,
              salesCurrency: 'EUR',
              hierarchyLevel: 3,
              isCreditLineActivated: true,
              isCreditLineCustomer: true,
              creditLineModel: 'Shared',
              subAgencies: []
            }
          ]
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusTwoLevelSharedNetworkParent(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          companyName: this.PARENT_COMPANY_NAME,
          initialAmount: 70000.0,
          openAmount: 55555.0,
          percentageUsed: 20.64,
          usedAmount: 14445.0,
          salesCurrency: 'USD',
          hierarchyLevel: 2,
          isCreditLineActivated: true,
          isCreditLineCustomer: true,
          creditLineModel: 'Shared',
          subAgencies: [
            {
              officeId: this.CHILD_OFFICE,
              companyName: this.CHILD_COMPANY_NAME,
              initialAmount: 70000.0 * this.USD_TO_BGN_RATE,
              openAmount: 55555.0 * this.USD_TO_BGN_RATE,
              percentageUsed: 20.64,
              usedAmount: 14445.0 * this.USD_TO_BGN_RATE,
              salesCurrency: 'BGN',
              hierarchyLevel: 3,
              isCreditLineActivated: true,
              isCreditLineCustomer: true,
              creditLineModel: 'Shared',
              subAgencies: []
            }
          ]
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusTwoLevelNetworkParentSplit(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          companyName: this.PARENT_COMPANY_NAME,
          initialAmount: 70000.0,
          initialAmountEuro: 70000.0 * this.USD_TO_EURO_RATE,
          openAmount: 55555.0,
          openAmountEuro: 55555.0 * this.USD_TO_EURO_RATE,
          percentageUsed: 20.64,
          usedAmount: 14445.0,
          salesCurrency: 'USD',
          hierarchyLevel: 2,
          isCreditLineActivated: true,
          isCreditLineCustomer: true,
          creditLineModel: 'Split',
          subAgencies: [
            {
              officeId: this.CHILD_OFFICE,
              companyName: this.CHILD_COMPANY_NAME,
              initialAmount: 20000.0,
              initialAmountEuro: 20000.0 * this.BGN_TO_EURO_RATE,
              openAmount: 5000.0,
              openAmountEuro: 5000.0 * this.BGN_TO_EURO_RATE,
              percentageUsed: 75.0,
              usedAmount: 15000,
              salesCurrency: 'BGN',
              hierarchyLevel: 3,
              isCreditLineActivated: true,
              isCreditLineCustomer: true,
              creditLineModel: 'Split',
              subAgencies: []
            }
          ]
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusTwoLevelNetworkParentSplitChildNotCreditLine(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          companyName: this.PARENT_COMPANY_NAME,
          initialAmount: 70000.0,
          initialAmountEuro: 70000.0 * this.USD_TO_EURO_RATE,
          openAmount: 55555.0,
          openAmountEuro: 55555.0 * this.USD_TO_EURO_RATE,
          percentageUsed: 20.64,
          usedAmount: 14445.0,
          salesCurrency: 'USD',
          hierarchyLevel: 2,
          isCreditLineActivated: true,
          isCreditLineCustomer: true,
          creditLineModel: 'Split',
          subAgencies: [
            {
              officeId: this.CHILD_OFFICE,
              companyName: this.CHILD_COMPANY_NAME,
              isCreditLineActivated: false,
              isCreditLineCustomer: true,
              creditLineModel: 'Split',
              subAgencies: []
            }
          ]
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusTwoLevelNetworkParentSplitChildNoAmount(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          companyName: this.PARENT_COMPANY_NAME,
          initialAmount: 70000.0,
          initialAmountEuro: 70000.0 * this.USD_TO_EURO_RATE,
          openAmount: 55555.0,
          openAmountEuro: 55555.0 * this.USD_TO_EURO_RATE,
          percentageUsed: 20.64,
          usedAmount: 14445.0,
          salesCurrency: 'USD',
          hierarchyLevel: 2,
          isCreditLineActivated: true,
          isCreditLineCustomer: true,
          creditLineModel: 'Split',
          subAgencies: [
            {
              officeId: this.CHILD_OFFICE,
              companyName: this.CHILD_COMPANY_NAME,
              initialAmount: 0.0,
              initialAmountEuro: 0.0,
              openAmount: 0,
              openAmountEuro: 0,
              percentageUsed: 0,
              usedAmount: 0,
              salesCurrency: 'BGN',
              hierarchyLevel: 3,
              isCreditLineActivated: true,
              isCreditLineCustomer: true,
              creditLineModel: 'Split',
              subAgencies: []
            }
          ]
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusTwoLevelSharedNetworkChild(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          companyName: this.CHILD_COMPANY_NAME,
          initialAmount: 70000.0,
          openAmount: 55555.0,
          percentageUsed: 20.64,
          usedAmount: 14445.0,
          salesCurrency: 'EUR',
          hierarchyLevel: 3,
          isCreditLineActivated: true,
          isCreditLineCustomer: true,
          creditLineModel: 'Shared',
          subAgencies: []
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusThreeLevelHead1(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          companyName: 'COMPANY UK',
          initialAmount: 0.0,
          openAmount: 0.0,
          percentageUsed: 0.0,
          usedAmount: 0.0,
          salesCurrency: 'EUR',
          hierarchyLevel: 1,
          isCreditLineActivated: true,
          isCreditLineCustomer: true,
          creditLineModel: 'Split',
          subAgencies: [
            {
              officeId: 'DDDDDDD02',
              companyName: 'COMPANY CREDIT LINE OWNER NEW ADMIN HEAD',
              initialAmount: 100000.0,
              openAmount: 80000.0,
              percentageUsed: 20.0,
              usedAmount: 20000.0,
              salesCurrency: 'EUR',
              hierarchyLevel: 2,
              isCreditLineActivated: true,
              isCreditLineCustomer: true,
              creditLineModel: 'Shared',
              subAgencies: [
                {
                  officeId: 'DDDDDDD16',
                  companyName: 'COMPANY  France DDDDDDD16',
                  initialAmount: 100000.0,
                  openAmount: 80000.0,
                  percentageUsed: 20.0,
                  usedAmount: 20000.0,
                  salesCurrency: 'EUR',
                  hierarchyLevel: 3,
                  isCreditLineActivated: true,
                  isCreditLineCustomer: true,
                  subAgencies: [],
                  initialAmountEuro: 100000.0,
                  openAmountEuro: 80000.0,
                  usedAmountEuro: 20000.0
                },
                {
                  officeId: 'DDDDDDD17',
                  companyName: 'COMPANY Norway',
                  initialAmount: 100000.0,
                  openAmount: 80000.0,
                  percentageUsed: 20.0,
                  usedAmount: 20000.0,
                  salesCurrency: 'EUR',
                  hierarchyLevel: 3,
                  isCreditLineActivated: true,
                  isCreditLineCustomer: true,
                  subAgencies: [],
                  initialAmountEuro: 100000.0,
                  openAmountEuro: 80000.0,
                  usedAmountEuro: 20000.0
                }
              ],
              initialAmountEuro: 100000.0,
              openAmountEuro: 80000.0,
              usedAmountEuro: 20000.0
            },
            {
              officeId: 'DDDDDDD03',
              companyName: 'COMPANY  UK DDDDDDD03',
              initialAmount: 10000.0,
              openAmount: 10000.0,
              percentageUsed: 0.0,
              usedAmount: 0.0,
              salesCurrency: 'EUR',
              hierarchyLevel: 2,
              isCreditLineActivated: true,
              isCreditLineCustomer: true,
              creditLineModel: 'Shared',
              subAgencies: [
                {
                  officeId: 'DDDDDDD18',
                  companyName: 'COMPANY UK (DDDDDDD18)',
                  initialAmount: 10000.0,
                  openAmount: 10000.0,
                  percentageUsed: 0.0,
                  usedAmount: 0.0,
                  salesCurrency: 'EUR',
                  hierarchyLevel: 3,
                  isCreditLineActivated: true,
                  isCreditLineCustomer: true,
                  subAgencies: [],
                  initialAmountEuro: 10000.0,
                  openAmountEuro: 10000.0,
                  usedAmountEuro: 0.0
                }
              ],
              initialAmountEuro: 10000.0,
              openAmountEuro: 10000.0,
              usedAmountEuro: 0.0
            },
            {
              officeId: 'DDDDDDD04',
              companyName: 'COMPANY Ltd DDDDDDD04',
              initialAmount: 15000.0,
              openAmount: 10000.0,
              percentageUsed: 33.33,
              usedAmount: 5000.0,
              salesCurrency: 'EUR',
              hierarchyLevel: 2,
              isCreditLineActivated: true,
              isCreditLineCustomer: true,
              creditLineModel: 'Shared',
              subAgencies: [
                {
                  officeId: 'DDDDDDD19',
                  companyName: 'COMPANY UK (DDDDDDD19)',
                  initialAmount: 15000.0,
                  openAmount: 10000.0,
                  percentageUsed: 33.33,
                  usedAmount: 5000.0,
                  salesCurrency: 'EUR',
                  hierarchyLevel: 3,
                  isCreditLineActivated: true,
                  isCreditLineCustomer: true,
                  subAgencies: [],
                  initialAmountEuro: 15000.0,
                  openAmountEuro: 10000.0,
                  usedAmountEuro: 5000.0
                }
              ],
              initialAmountEuro: 15000.0,
              openAmountEuro: 10000.0,
              usedAmountEuro: 5000.0
            }
          ],
          initialAmountEuro: 0.0,
          openAmountEuro: 0.0,
          usedAmountEuro: 0.0
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusTwoLevelSplitNetworkChild(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          companyName: this.CHILD_COMPANY_NAME,
          initialAmount: 70000.0,
          openAmount: 55555.0,
          percentageUsed: 20.64,
          usedAmount: 14445.0,
          salesCurrency: 'EUR',
          hierarchyLevel: 3,
          isCreditLineActivated: true,
          isCreditLineCustomer: true,
          creditLineModel: 'Split',
          subAgencies: []
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusTwoLevelNetworkParentNegativePercentage(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          companyName: this.PARENT_COMPANY_NAME,
          initialAmount: 2000.0,
          openAmount: 1000.0,
          percentageUsed: -50.0,
          usedAmount: 1000.0,
          salesCurrency: 'EUR',
          hierarchyLevel: 2,
          isCreditLineActivated: true,
          isCreditLineCustomer: true,
          creditLineModel: 'Shared',
          subAgencies: [
            {
              officeId: this.CHILD_OFFICE,
              companyName: this.CHILD_COMPANY_NAME,
              initialAmount: 2000.0,
              openAmount: 1000.0,
              percentageUsed: -50.0,
              usedAmount: 1000.0,
              salesCurrency: 'EUR',
              hierarchyLevel: 3,
              isCreditLineActivated: true,
              isCreditLineCustomer: true,
              creditLineModel: 'Shared',
              subAgencies: []
            }
          ]
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }

  public getCreditLineStatusSplitCreditLineModel(officeId: string) {
    return {
      headers: {},
      body: {
        requestedOfficeId: officeId,
        agencyData: {
          officeId: officeId,
          companyName: this.PARENT_COMPANY_NAME,
          initialAmount: 2000.0,
          openAmount: 1000.0,
          percentageUsed: -50.0,
          usedAmount: 1000.0,
          salesCurrency: 'EUR',
          hierarchyLevel: 2,
          isCreditLineActivated: true,
          isCreditLineCustomer: true,
          creditLineModel: 'Split',
          subAgencies: [
            {
              officeId: this.CHILD_OFFICE,
              companyName: this.CHILD_COMPANY_NAME,
              initialAmount: 2000.0,
              openAmount: 1000.0,
              percentageUsed: -50.0,
              usedAmount: 1000.0,
              salesCurrency: 'EUR',
              hierarchyLevel: 3,
              isCreditLineActivated: true,
              isCreditLineCustomer: true,
              creditLineModel: 'Split',
              subAgencies: []
            }
          ]
        }
      },
      statusCode: 'OK',
      statusCodeValue: 200
    };
  }
}
